import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';
import area from 'modules/area';

interface Props {
  onClick?: () => void;
  valueChange?: () => void;
  type?: 'province' | 'city';
  className?: string;
  showProvince: boolean
  showCity: boolean
}

interface State {
  arrName: string
  
}

export default class areaSelect extends React.Component<any> {

  public state: State = {
    arrName: ''
  }

  public componentDidShow() {

  }

  private province = (ind,opt) => {
    let that = this;
    
    that.setState({
      arrName: '0_'+ind
    })

    this.props.valueChange('province',opt)
  }

  private city = (ind,opt) => {
    this.props.valueChange('city',opt)
  }

  private closeFun = () => {
    this.props.valueChange('close')
  }

	public render() {
    	const { showCity, showProvince, className } = this.props;
      const { arrName } = this.state;
      // console.log(showCity , showProvince)
    	return (
        <div className={cx(styles.areaBox, (showProvince || showCity) && styles.show ,className)}>
          <div className={styles.bg} onClick={this.closeFun}></div>
          {showProvince && (
            <div className={cx(styles.list, showProvince && styles.show)}>
              {area[0].map((option, index) => {
                return (
                  <div key={index} 
                    className={styles.items}
                    onClick={this.province.bind(null,index,option)}
                  >{option}</div>
                )
              })}
            </div>
          )}
          {showCity && (
            <div className={cx(styles.list, showCity && styles.show)}>
              {area[arrName] && area[arrName].map((option, index) => {
                return (
                  <div key={index} 
                    className={styles.items}
                    onClick={this.city.bind(null,index,option)}
                  >{option}</div>
                )
              })}
            </div>
          )}
        </div>
    	)
  }
}
